package org.multiplatform.kotfolio.pages.kids.hirva.result

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import kotlinx.browser.document
import kotlinx.collections.immutable.ImmutableList
import kotlinx.collections.immutable.persistentListOf
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Table
import org.jetbrains.compose.web.dom.Tbody
import org.jetbrains.compose.web.dom.Td
import org.jetbrains.compose.web.dom.Th
import org.jetbrains.compose.web.dom.Thead
import org.jetbrains.compose.web.dom.Tr
import org.jetbrains.compose.web.dom.Text
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLObjectElement

@Page("/kids/hirva/result/grade2")
@Composable
fun Result2Page() {
    LaunchedEffect(Unit) {
        val style = document.createElement("style")
        style.textContent = """
            @keyframes adminRowIn {
                from { opacity: 0; transform: translateX(-6px); }
                to   { opacity: 1; transform: translateX(0); }
            }
        """.trimIndent()
        document.head?.appendChild(style)
    }

    BlogLayout(
        PageProperties(
            "Gen. Alpha",
            ""
        ),
        BlogProperties("Result Grade-2", "LAKHANI HIRVA")
    ) {
        val examList = persistentListOf(
            Exam(
                examNo = "TEST - 1",
                grade = "A",
                resultList = persistentListOf(
                    Result(
                        examDate = "29-Jun-2026",
                        subject = "ENGLISH",
                        topicList = persistentListOf(
                            "Now that I can Read",
                            "Sakhi's Wiggly Tooth",
                            "The Wacky 'w'",
                            "Noun",
                            "Gender",
                            "Reading Comprehension"
                        ),
                        achieveGrade = "A",
                        targetGrade = "C"
                    ),

                    Result(
                        examDate = "30-Jun-2026",
                        subject = "HINDI",
                        topicList = persistentListOf(
                            "वर्णमाला-स्वर तथा व्यंजन (पुनः अभ्यास)",
                            "मात्रा- अ से ऋ",
                            "मात्रा- ए से ऑ",
                            "अन्य व्यंजन (पुनः अभ्यास)",
                            "जानकारी- गिनती १ से ५ अंक और शब्द"
                        ),
                        achieveGrade = "A",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "01-Jul-2026",
                        subject = "EVS",
                        topicList = persistentListOf("Our Family", "Community Helpers"),
                        achieveGrade = "A",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "02-Jul-2026",
                        subject = "MATH",
                        topicList = persistentListOf(
                            "Numbers up to 999",
                            "Enjoy with Numbers (till ordering numbers)"
                        ),
                        achieveGrade = "A",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "03-Jul-2026",
                        subject = "GUJARATI",
                        topicList = persistentListOf(
                            "અ (બે અક્ષર વાળા શબ્દો)",
                            "અ (ત્રણ અક્ષર વાળા શબ્દો)",
                            "અ (ચાર અક્ષર વાળા શબ્દો)"
                        ),
                        achieveGrade = "A",
                        targetGrade = "A"
                    )
                )
            ),

            Exam(
                examNo = "TEST - 2",
                grade = "Grade A",
                resultList = persistentListOf(
                    Result(
                        examDate = "27-Jul-2026",
                        subject = "EVS",
                        topicList = persistentListOf("Places I like to Visit", "Shelter"),
                        achieveGrade = "",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "28-Jul-2026",
                        subject = "ENGLISH",
                        topicList = persistentListOf(
                            "Abdullah the Mason",
                            "The Sounds of 'x'",
                            "Singular and Plural",
                            "Articles",
                            "Picture To Talk"
                        ),
                        achieveGrade = "",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "29-Jul-2026",
                        subject = "GUJARATI",
                        topicList = persistentListOf("આ", "ઇ", "ઈ", "ઉ", "ઊ"),
                        achieveGrade = "",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "30-Jul-2026",
                        subject = "HINDI",
                        topicList = persistentListOf(
                            "सोने का अंडा",
                            "बारहखड़ी (पुनः अभ्यास)",
                            "व्याकरण – 'र' के सही रूप",
                            "शरीर के अंग"
                        ),
                        achieveGrade = "",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "31-Jul-2026",
                        subject = "MATH",
                        topicList = persistentListOf(
                            "Enjoy with Numbers (from even and odd numbers)", "Addition"
                        ),
                        achieveGrade = "",
                        targetGrade = "A"
                    )
                )
            ),

            Exam(
                examNo = "TEST - 3",
                grade = "Grade A",
                resultList = persistentListOf(
                    Result(
                        examDate = "24-Aug-2026",
                        subject = "EVS",
                        topicList = persistentListOf("Our School", "Air"),
                        achieveGrade = "A",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "25-Aug-2026",
                        subject = "ENGLISH",
                        topicList = persistentListOf(
                            "The Silent 'u'",
                            "The Little Turtle",
                            "Double Trouble",
                            "Being Verb",
                            "'ing' verb",
                            "Comprehension"
                        ),
                        achieveGrade = "A",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "27-Aug-2026",
                        subject = "MATH",
                        topicList = persistentListOf("Subtraction"),
                        achieveGrade = "A",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "29-Aug-2026",
                        subject = "GUJARATI",
                        topicList = persistentListOf(
                            "એ, ઐ, ઓ, ઔ"
                        ),
                        achieveGrade = "A",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "31-Aug-2026",
                        subject = "HINDI",
                        topicList = persistentListOf(
                            "कविता – देश हमारा",
                            "व्याकरण – संयुक्त व्यंजन",
                            "व्याकरण – वर्तनी",
                            "जानकारी – सप्ताह के दिन"
                        ),
                        achieveGrade = "A",
                        targetGrade = "A"
                    )
                )
            ),

            Exam(
                examNo = "TEST - 4",
                grade = "Grade A",
                resultList = persistentListOf(
                    Result(
                        examDate = "29-Sep-2026",
                        subject = "Gujarati",
                        topicList = persistentListOf("અનુસ્વાર", "અં, એ, ઓ", "ક", "શૈલધરી"),
                        achieveGrade = "A+",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "01-Oct-2026",
                        subject = "Hindi",
                        topicList = persistentListOf("हरियाली", "व्याकरण - शब्द", "जानकारी - गिनती १ से १० अंक और शब्द", "रचना - चित्र देखकर कहानी लिखना"),
                        achieveGrade = "A+",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "5-Oct-2026",
                        subject = "English",
                        topicList = persistentListOf(
                            "Ch. 5 Tucket the Bucket",
                            "Ch. 5 Sounds of ‘c’ and ‘g’",
                            "Ch. 8 Pronoun",
                            "Ch. 17 Picture Sequencing"
                        ),
                        achieveGrade = "A+",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "07-Oct-2026",
                        subject = "EVS",
                        topicList = persistentListOf("Our Body", "Water"),
                        achieveGrade = "A+",
                        targetGrade = "A"
                    ),

                    Result(
                        examDate = "09-Oct-2026",
                        subject = "Math",
                        topicList = persistentListOf("Shapes", "Measurement"),
                        achieveGrade = "A+",
                        targetGrade = "A"
                    )
                )
            ),
        )

        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "How to achieve Grade - A",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Pray daily and bless one another. You go to outside speak god name.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Which topic today learning.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "You ask teacher question: Ask question, kids replay or not. Check kids behaviour.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Get result compare parent and child.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Daily report create.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }



            examList.forEach { exam ->
                SpanText(
                    text = "${exam.examNo}  (GRADE - ${exam.grade})",
                    modifier = Modifier
                        .fillMaxWidth()
                        .textAlign(TextAlign.Center)
                        .fontSize(FontSize.Large).padding(top = 5.em)
                        .fontWeight(FontWeight.Bold)
                )

                Div({
                    style {
                        property("overflow-x", "auto")
                        property("width", "100%")
                        property("max-width", "100vw") // Explicitly constrain to viewport width
                        property("display", "block")
                        property("-webkit-overflow-scrolling", "touch") // Smooth scroll for iOS
                    }
                }) {
                    Table({
                        style {
                            property("width", "100%")
                            property("border-collapse", "collapse")
                            property("font-size", "15px")
                            property("min-width", "1000px")
                        }
                    }) {
                        Thead {
                            Tr({
                                style {
                                    property("border-bottom", "2px solid #eee")
                                }
                            }) {
                                listOf(
                                    "Exam Date",
                                    "Subject",
                                    "Grade",
                                    "Goal",
                                    "Topic",
                                ).forEach { header ->
                                    Th({
                                        style {
                                            property("padding", "11px 16px")
                                            property("text-align", "left")
                                            property("font-size", "16px")
                                            property("font-weight", "700")
                                            property("text-transform", "uppercase")
                                            property("letter-spacing", "0.06em")
                                            property("color", "#000000")
                                            property(
                                                "white-space", "nowrap"
                                            )
                                        }
                                    }) { Text(header) }
                                }
                            }
                        }

                        Tbody {
                            exam.resultList.forEachIndexed { index, result ->
                                val rowDelay = "${(index * 0.04).coerceAtMost(0.4)}s"

                                Tr({
                                    style {
                                        property("border-bottom", "1px solid #eee")
                                        if (index % 2 == 0) property(
                                            "background",
                                            "rgba(0,0,0,0.012)"
                                        )
                                        property("animation", "adminRowIn 0.3s ease $rowDelay both")
                                    }
                                }) {
                                    TCell(result.examDate)
                                    TCell(result.subject)
                                    TCell(result.achieveGrade, bold = true, green = true)
                                    TCell(result.targetGrade)
                                    TCell(result.topicList.joinToString(", "), wrap = true)
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

@Composable
private fun TCell(
    value: String,
    bold: Boolean = false,
    green: Boolean = false,
    red: Boolean = false,
    mono: Boolean = false,
    wrap: Boolean = false,
) {
    Td({
        style {
            property("padding", "13px 16px")
            if (wrap) {
                property("white-space", "normal")
                property("min-width", "300px")
            } else {
                property("white-space", "nowrap")
            }
            when {
                green -> { property("color", "#10b981"); property("font-weight", "600") }
                red   -> { property("color", "#ef4444"); property("font-weight", "600") }
                bold  -> property("font-weight", "600")
            }
            if (mono) property("font-family", "ui-monospace, monospace")
        }
    }) { Text(value) }
}

data class Exam (
    val examNo: String = "",
    val grade: String = "",
    val resultList: ImmutableList<Result> = persistentListOf()
)

data class Result(
    val examDate: String = "",
    val subject: String = "",
    val topicList: ImmutableList<String> = persistentListOf(),
    val achievedMark : Double = 0.0,
    val achieveGrade: String = "",
    val targetGrade: String = "",
    val totalMark: Int = 0
)